import { render } from "./CollectionPage.vue?vue&type=template&id=64fb1d82&scoped=true"
import script from "./CollectionPage.vue?vue&type=script&lang=js"
export * from "./CollectionPage.vue?vue&type=script&lang=js"

import "./CollectionPage.vue?vue&type=style&index=0&id=64fb1d82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fb1d82"]])

export default __exports__